<section class="testimonials-section py-5" id="testimonials">
  <div class="container">
    <div class="text-center mb-5">
      <h2 class="section-title">{{ i18n.getTranslation('testimonials.title') }}</h2>
      <p class="section-subtitle">{{ i18n.getTranslation('testimonials.subtitle') }}</p>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="testimonials-list">
          <div
            class="testimonial-item"
            *ngFor="let testimonial of visibleTestimonials; let i = index"
            [class.animate-in]="testimonial.isVisible">
            <div class="testimonial-content">
              <div class="quote-icon">
                <i class="fas fa-quote-left"></i>
              </div>
              <p class="testimonial-text">{{ testimonial.text }}</p>
              <div class="testimonial-author">
                <div class="author-info">
                  <h5 class="author-name">{{ testimonial.author }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-4" *ngIf="testimonials.length > 1">
          <button
            class="btn btn-outline-primary"
            (click)="toggleTestimonials()">
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
